<!-- Router outlet for child routes (review-tabs) -->
<router-outlet></router-outlet>

<!-- Main Q&A Pair content - only show when not on child route -->
@if (!isChildRouteActive()) {
<div class="h-full flex flex-col w-100 gap-2 p-2">
    <!-- Desktop Header -->
    <div class="hidden md:flex items-center justify-between gap-2 w-full">
        <div class="flex items-center gap-2 flex-1 min-w-0">
            <div class="flex-shrink-0">
                <app-select [(value)]="documentTypeId" [options]="documentTypeOptions" [config]="documentTypeConfig"
                    [itemTemplate]="documentTypeItem" (onChange)="handleChange($event)">
                </app-select>
            </div>

            <ng-template #documentTypeItem let-option>
                <div class="text-sm py-0.5">
                    {{ option.label }}
                </div>
            </ng-template>

            <div class="flex-1">
                <app-search-bar placeholder="Search by question or answer" [(ngModel)]="searchValue"
                    (searchChange)="onSearch()" width="100%">
                </app-search-bar>
            </div>
        </div>

        <div class="flex flex-row items-center justify-end flex-shrink-0 gap-3">
            <!-- Mobile Menu (only visible between md and xl) -->
            <div class="xl:hidden">
                <ng-container *ngTemplateOutlet="mobileMenuTemplate"></ng-container>
            </div>

            <!-- Desktop Action Buttons (only visible on xl and above) -->
            <div class="hidden xl:flex flex-row items-center gap-2">
                <ng-container *ngTemplateOutlet="addQnaPopoverTemplate"></ng-container>
                <app-button label="Filters" variant="outlined" severity="contrast" icon="pi pi-filter"
                    (clicked)="openFilterDialog()" />
                <app-button label="History" variant="outlined" icon="pi pi-history" severity="contrast"
                    (clicked)="getUploadedFilesAudit(true)" />
                <div>
                    <app-button label="Review Q&A" variant="outlined" severity="contrast" icon="pi pi-book"
                        (clicked)="openReviewQnA()" />
                </div>
            </div>
        </div>
    </div>

    <!-- Mobile Header (only visible below md) -->
    <div class="md:hidden flex flex-col gap-2 w-full">
        <div class="flex items-center gap-2 w-full">
            <div class="flex-1 min-w-0 overflow-hidden">
                <app-select [(value)]="documentTypeId" [options]="documentTypeOptions" [config]="documentTypeConfig"
                    [itemTemplate]="documentTypeItem" (onChange)="handleChange($event)">
                </app-select>
            </div>

            <div class="flex-shrink-0">
                <ng-container *ngTemplateOutlet="mobileMenuTemplate"></ng-container>
            </div>
        </div>

        <div class="w-full">
            <app-search-bar placeholder="Search by question or answer" [(ngModel)]="searchValue"
                (searchChange)="onSearch()" width="100%">
            </app-search-bar>
        </div>
    </div>
</div>


<div class="flex flex-col h-full p-2">
    <!-- Action Bar -->
    <div class="action-bar" *ngIf="selectedPairsIds.length > 0">
        <div class="selection-count">
            {{ selectedPairsIds.length }} item(s) selected
        </div>
        <div class="border-l border-gray-300 h-4 mx-2"></div>
        <ng-container *ngTemplateOutlet="actionButtonsTemplate"></ng-container>
    </div>

    <!-- Data Table -->
    <div [style.height]="selectedPairsIds.length > 0 ? 'calc(100vh - 13rem)' : 'calc(100vh - 8rem)'">
        <app-data-table #dataTable [data]="qnaData" [columns]="qnaTableColumns" [config]="qnaTableConfig"
            [dataKey]="'_id'" tableClass="flex-1" [customTemplates]="templatesMap"
            (selectionChange)="onSelectionChange($event)" (pageChange)="onPageChange($event)">
        </app-data-table>

        <div *ngIf="qnaLoading && qnaData.length > 0" class="flex justify-center items-center py-4">
            <p-progressSpinner class="w-6 h-6"></p-progressSpinner>
            <span class="ml-2 text-sm text-gray-600">Loading more data...</span>
        </div>
    </div>
</div>
}

<!-- REUSABLE TEMPLATES -->

<!-- Mobile Menu Template -->
<ng-template #mobileMenuTemplate>
    <app-popover #mobileMenuPopover [width]="'auto'" [maxHeight]="'50vh'" [showScrollbar]="true">
        <ng-template #trigger>
            <app-button icon="pi pi-ellipsis-v" variant="outlined" severity="contrast" />
        </ng-template>
        <ng-template #body>
            <div class="flex flex-col gap-1 min-w-12.5rem">
                <div class="flex flex-row items-center p-2 cursor-pointer hover:bg-gray-100 rounded"
                    (click)="importQna(); mobileMenuPopover.hide()">
                    <span class="pi pi-upload"></span>
                    <span class="ml-2">Upload Q&A</span>
                </div>
                <div class="flex flex-row items-center p-2 cursor-pointer hover:bg-gray-100 rounded"
                    (click)="addManualQna(); mobileMenuPopover.hide()">
                    <span class="pi pi-plus-circle"></span>
                    <span class="ml-2">Add manual Q&A</span>
                </div>
                <div class="flex flex-row items-center p-2 cursor-pointer hover:bg-gray-100 rounded"
                    (click)="openFilterDialog(); mobileMenuPopover.hide()">
                    <span class="pi pi-filter"></span>
                    <span class="ml-2">Filters</span>
                </div>
                <div class="flex flex-row items-center p-2 cursor-pointer hover:bg-gray-100 rounded"
                    (click)="getUploadedFilesAudit(true); mobileMenuPopover.hide()">
                    <span class="pi pi-history"></span>
                    <span class="ml-2">History</span>
                </div>
                <div class="flex flex-row items-center p-2 cursor-pointer hover:bg-gray-100 rounded"
                    (click)="openReviewQnA(); mobileMenuPopover.hide()">
                    <span class="pi pi-book"></span>
                    <span class="ml-2">Review Q&A</span>
                </div>
            </div>
        </ng-template>
    </app-popover>
</ng-template>

<!-- Add Q&A Popover Template -->
<ng-template #addQnaPopoverTemplate>
    <app-popover #addQnaPopover [width]="'auto'" [maxHeight]="'20vh'" [showScrollbar]="true">
        <ng-template #trigger>
            <app-button label="Add Q&A" variant="outlined" severity="contrast" icon="pi pi-plus" />
        </ng-template>
        <ng-template #body>
            <div class="flex flex-col gap-1">
                <div class="flex flex-row items-center py-2 px-3 cursor-pointer hover:bg-gray-100 rounded"
                    (click)="importQna(); addQnaPopover.hide()">
                    <span class="pi pi-upload"></span>
                    <span class="ml-2">Upload Q&A</span>
                </div>
                <div class="flex flex-row items-center py-2 px-3 cursor-pointer hover:bg-gray-100 rounded"
                    (click)="addManualQna(); addQnaPopover.hide()">
                    <span class="pi pi-plus-circle"></span>
                    <span class="ml-2">Add manual Q&A</span>
                </div>
            </div>
        </ng-template>
    </app-popover>
</ng-template>

<!-- Action Buttons Template -->
<ng-template #actionButtonsTemplate>
    <div class="action-buttons flex items-center gap-2 flex-wrap">
        <app-button label="Edit Selected" variant="outlined" icon="pi pi-pen-to-square" (clicked)="onBulkEdit()"
            [enableThrottle]="true" />
        <app-button label="Download Selected" variant="outlined" icon="pi pi-download"
            (clicked)="showDownloadDialog=true" />
        <div class="border-l border-gray-300 h-4 mx-2 hidden sm:block"></div>
        <app-button label="Delete Selected" variant="outlined" icon="pi pi-trash" (clicked)="onBulkDelete()"
            pTooltip="Delete Selected" tooltipPosition="top" severity="danger" />
    </div>
</ng-template>

<!-- Bulk Edit Dialog -->
<app-dialog [(visible)]="showBulkEditDialog" (closed)="onCancelBulkEdit()" [fullscreenOnMobile]="true"
    class="max-w-[70vw] h-[70vh]">
    <ng-template #headerTemplate>
        <div class="flex items-center gap-2">
            <span class="font-semibold text-lg">Edit Q&amp;A</span>
            <span class="text-sm text-gray-600">({{ currentEditIndex + 1 }}/{{ totalEditingCount }})</span>
        </div>
    </ng-template>
    <ng-template #bodyTemplate>
        <div class="h-full flex flex-row justify-between p-4 gap-4">
            <div class="h-full w-[40%]">
                <div class="qna-cards-container mb-4" infiniteScroll [infiniteScrollThrottle]="500"
                    (scrolled)="onScrollEditDialog()" [infiniteScrollDistance]="1" [scrollWindow]="false">
                    <div #qnaCard *ngFor="let pair of editingPairs; let i = index"
                        class="qna-card mb-3 p-3 border rounded-base cursor-pointer transition-all bg-white border-gray-200 shadow-sm"
                        [ngClass]="{'selected-card': currentEditIndex === i}" (click)="selectQnaPair(i)">
                        <div class="overflow-auto">
                            <div class="font-semibold text-sm mb-2 truncate">{{ pair.question }}</div>
                            <div class="text-xs text-gray-600 truncate">{{ pair.answer }}</div>
                        </div>
                        <div>
                            @if(savedPairs.has(i)) {
                            <div class="flex flex-col gap-1 items-center">
                                <i class="pi pi-check-circle text-success"></i>
                                <span class="text-xs text-success">Done</span>
                            </div>
                            } @else if(currentEditIndex === i) {
                            <i class="pi pi-chevron-right font-bold"></i>
                            }
                        </div>
                    </div>
                    @if(isLoadingMorePairs) {
                    <div class="flex justify-center items-center py-4">
                        <p-progressSpinner class="w-6 h-6"></p-progressSpinner>
                    </div>
                    }
                </div>
            </div>
            <div class="h-full w-[60%]">
                <div *ngIf="editingPairs[currentEditIndex]"
                    class="flex flex-col border-2 border-gray-100 rounded-base p-4 h-full">
                    <div class="field">
                        <label class="flex text-sm font-medium mb-2">Question</label>
                        <textarea pInputTextarea [(ngModel)]="editingPairs[currentEditIndex].question"
                            (ngModelChange)="savePair(currentEditIndex)" class="w-full" rows="1"
                            placeholder="Enter question..."></textarea>
                    </div>
                    <div class="field">
                        <label class="flex text-sm font-medium mb-2">Answer</label>
                        <textarea pInputTextarea [(ngModel)]="editingPairs[currentEditIndex].answer"
                            (ngModelChange)="savePair(currentEditIndex)" class="w-full" rows="3"
                            placeholder="Enter answer..."></textarea>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex justify-between items-center w-full">
            <div class="flex items-center gap-2">
                <app-button label="Prev" variant="outlined" icon="pi pi-chevron-left" (clicked)="navigatePrevious()"
                    [disabled]="isPreviousDisabled" />
                <app-button label="Next" variant="outlined" icon="pi pi-chevron-right" (clicked)="navigateNext()"
                    [disabled]="isNextDisabled" />
            </div>
            <div class="flex gap-2">
                <app-button label="Cancel" variant="outlined" severity="contrast" icon="pi pi-times"
                    (clicked)="onCancelBulkEdit()" />
                <app-button label="Save ({{ savedPairs.size }}/{{ totalEditingCount }})" variant="filled"
                    icon="pi pi-save" (clicked)="onSaveBulkEdit()" [disabled]="isSaveDisabled" [loading]="isSaving"
                    severity="primary" />
            </div>
        </div>
    </ng-template>
</app-dialog>

<!-- Manual Q&A Dialog -->
<app-dialog [(visible)]="showManualQnaDialog" [title]="isEditing ? 'Edit Q&A' : 'Add Q&A Pair'"
    (closed)="showManualQnaDialog = false; clearSelections()" class="max-w-[31.25rem]" [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        <div class="flex flex-col px-4">
            <p class="text-sm font-semibold">Question<span class="text-xs text-gray-500"> *</span></p>
            <div class="my-2">
                @if(isEditing && selectedPair) {
                <input type="text" placeholder="Type here"
                    class="w-full p-3 border border-gray-300 rounded-base text-sm outline-none placeholder:italic placeholder:text-gray-400 focus:border-orange-500"
                    [(ngModel)]="selectedPair.question" />
                } @else {
                <input type="text" placeholder="Type here"
                    class="w-full p-3 border border-gray-300 rounded-base text-sm outline-none placeholder:italic placeholder:text-gray-400 focus:border-orange-500"
                    [(ngModel)]="questionText" />
                }
            </div>
            <p class="text-sm font-semibold">Answer<span class="text-xs text-gray-500"> *</span></p>
            <div class="my-2">
                @if(isEditing && selectedPair) {
                <textarea placeholder="Type here" rows="1"
                    class="w-full p-3 border border-gray-300 rounded-base text-sm outline-none placeholder:italic placeholder:text-gray-400 focus:border-orange-500 resize-none"
                    [(ngModel)]="selectedPair.answer"></textarea>
                } @else {
                <textarea placeholder="Type here" rows="3"
                    class="w-full p-3 border border-gray-300 rounded-base text-sm outline-none placeholder:italic placeholder:text-gray-400 focus:border-orange-500 resize-none"
                    [(ngModel)]="answerText"></textarea>
                }
            </div>
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex gap-2 justify-end">
            <app-button label="Cancel" variant="outlined" severity="contrast" icon="pi pi-times"
                (clicked)="showManualQnaDialog = false; clearSelections()" />
            <app-button label="Save" variant="filled" (clicked)="saveQnaData()" [enableThrottle]="true"
                severity="primary" icon="pi pi-save" [disabled]="!checkValidation() || saveManualQnaLoading"
                [loading]="saveManualQnaLoading" />
        </div>
    </ng-template>
</app-dialog>

<!-- Expand Cell Dialog -->
<app-dialog [(visible)]="expandCell" [title]="expandedCellType" (closed)="expandCell = false"
    class="max-w-[80vw]" [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        <div class="px-4 pb-4">
            <div class="prose prose-compact text-justify text-md prose-ul:pl-1 prose-ol:pl-2 overflow-x-auto"
                [innerHTML]="expandedCellContent | formatText : false" dynamicComponentRenderer
                style="line-height:1.5rem;">
            </div>
        </div>
    </ng-template>
</app-dialog>

<!-- Filter Drawer -->
@if(filterDialog) {
<p-drawer [(visible)]="filterDialog" position="right">
    <ng-template pTemplate="headless">
        <div class="flex items-center justify-between p-4 flex-shrink-0 border-b">
            <span class="text-lg font-semibold">Filter</span>
            <div class="flex gap-2 items-center">
                <i class="pi pi-times cursor-pointer" (click)="filterDialog=false"></i>
            </div>
        </div>
        <div class="flex flex-col h-full justify-between">
            <div class="p-3 gap-y-4 flex flex-col">
                <div>
                    <div class="text-sm font-semibold">Author</div>
                    <app-multi-select [options]="userOptions" [(value)]="selectedAuthors" optionLabel="label"
                        optionValue="value" [config]="{placeholder: 'Select author', styleClass: 'w-full'}">
                    </app-multi-select>
                </div>
                <div>
                    <div class="text-sm font-semibold">Reviewed By</div>
                    <app-multi-select [options]="userOptions" [(value)]="selectedReviewers" optionLabel="label"
                        optionValue="value" [config]="{placeholder: 'Select reviewed by', styleClass: 'w-full'}">
                    </app-multi-select>
                </div>
                <div>
                    <div class="text-sm font-semibold">Times used</div>
                    <div class="flex items-center gap-2">
                        <div class="w-full">
                            <input type="number" [(ngModel)]="minTimeUsed" [min]="0" placeholder="Min Range"
                                class="w-full border rounded-base px-3 py-2 text-gray-700" />
                        </div>
                        <div class="mx-1 text-gray-400 font-semibold flex items-center justify-center">-</div>
                        <div class="w-full">
                            <input type="number" [(ngModel)]="maxTimeUsed" [min]="minTimeUsed" placeholder="Max Range"
                                class="w-full border rounded-base px-3 py-2 text-gray-700" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-3 flex justify-between gap-2">
                <div class="flex-1 flex justify-start">
                    <app-button label="Clear all and apply" variant="outlined" icon="pi pi-times"
                        (clicked)="clearFilter()" />
                </div>
                <div class="flex-1 flex justify-end">
                    <app-button label="Apply" variant="filled" icon="pi pi-check" (clicked)="applyFilter()"
                        [enableThrottle]="true" severity="primary" />
                </div>
            </div>
        </div>
    </ng-template>
</p-drawer>
}


<!-- Delete Confirm Dialog -->
<app-delete-confirmation [(visible)]="showDeleteConfirmDialog" headerText="Are you sure?"
    [bodyText]="itemsToDeleteCount === 1 ? 'Are you sure you want to Delete this Q/A Pair?' : 'Are you sure you want to delete these ' + itemsToDeleteCount + ' Q/A Pairs?'"
    confirmButtonText="Yes, delete" (onConfirm)="confirmDelete()" (onCancel)="cancelDelete()">
</app-delete-confirmation>

<!-- Download Dialog -->
<app-dialog [(visible)]="showDownloadDialog" (closed)="showDownloadDialog = false"
    class="max-w-[40vw] h-[60vh]" [fullscreenOnMobile]="true">
    <ng-template #headerTemplate>
        <div class="flex flex-col">
            <span class="text-lg font-semibold">Export</span>
            <span class="text-sm text-gray-600">Select your preferred file format for export.</span>
        </div>
    </ng-template>
    <ng-template #bodyTemplate>
        <div class="flex flex-col p-4 h-full overflow-visible">
            <div class="flex justify-center">
                <div class="export-file">
                    <img [src]="'images/export_qna.svg' | assetUrl" alt="link" class="relative z-10">
                    <div class="vector-export-left">
                        <img [src]="'images/orange-top.svg' | assetUrl" alt="">
                    </div>
                    <div class="vector-export-right">
                        <img [src]="'images/blue-bottom.svg' | assetUrl" alt="">
                    </div>
                </div>
            </div>
            <div class="flex flex-col mt-4">
                <span class="text-sm font-semibold">Download as</span>
                <app-select [(value)]="exportType" [options]="fileOptions" [config]="fileSelectConfig" />
            </div>
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex justify-end gap-2">
            <app-button label="Cancel" variant="outlined" severity="contrast" icon="pi pi-times"
                (clicked)="showDownloadDialog = false" />
            <app-button label="Download" variant="filled" icon="pi pi-download" (clicked)="onDownload()"
                [enableThrottle]="true" [disabled]="!exportType" [loading]="isDownloading" severity="primary" />
        </div>
    </ng-template>
</app-dialog>

<!-- Upload Dialog -->
<app-dialog [(visible)]="showUploadDialog" title="Upload Documents" (closed)="closeUploadDialog()"
    class="max-w-[30rem]" [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        <div class="flex gap-3 flex-col items-center p-4">
            <span class="text-gray-500 text-sm items-center text-center">
                Extract questions and answers directly from your uploaded documents.
            </span>
            <app-file-drop class="w-full" [maxFileSize]="50*1000*1000" [fileTypes]="allowedFileTypes"
                (uploadData)="onFileSelect($event)" (removeFile)="removeFile($event)" [multiple]="true"
                [existingFiles]="selectedFiles"></app-file-drop>
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex gap-3 justify-end">
            <app-button label="Cancel" variant="outlined" severity="contrast" icon="pi pi-times"
                (clicked)="closeUploadDialog()" />
            <app-button label="Save" variant="filled" (clicked)="processUploadedFiles()" [enableThrottle]="true"
                icon="pi pi-save" [disabled]="selectedFiles.length === 0 || isProcessingUpload"
                [loading]="isProcessingUpload" severity="primary" />
        </div>
    </ng-template>
</app-dialog>

<!-- Document Preview Dialog (Files Audit) -->
<app-dialog [(visible)]="showQnaDocumentPreview" [fullscreenOnMobile]="true"
    class="max-w-[70vw] h-[85vh]" (closed)="closeQnaDocumentPreview()">
    <ng-template #headerTemplate>
        <span class="font-semibold text-lg truncate">{{ selectedQnaDocumentFile?.filename }}</span>
    </ng-template>
    <ng-template #bodyTemplate>
        <div class="h-full w-full">
            @if (selectedQnaDocumentFile && selectedQnaDocumentId) {
            <app-multi-format-preview [documentId]="selectedQnaDocumentId" [file]="selectedQnaDocumentFile">
            </app-multi-format-preview>
            }
        </div>
    </ng-template>
</app-dialog>

<!-- Files Audit Sidebar -->
@if(openFilesAuditSidebar) {
<p-drawer [(visible)]="openFilesAuditSidebar" position="right" [style]="{width: '30rem'}" closable="false">
    <ng-template pTemplate="headless">
        <div class="flex items-center w-full justify-between border-b p-4">
            <div class="flex items-center justify-start">
                <span class="!text-xl font-bold">Uploaded Files Audit</span>
            </div>
            <div class="flex items-center justify-end">
                <i class="pi pi-times cursor-pointer" (click)="openFilesAuditSidebar=false"></i>
            </div>
        </div>
        <div class="flex flex-col gap-3 p-4">
            @if(uploadedFilesAudit[documentTypeId] && uploadedFilesAudit[documentTypeId].length === 0) {
            <div class="flex flex-row items-center justify-between gap-2 text-gray-500">
                <span class="text-md">No uploaded files yet</span>
            </div>
            } @else {
            @for(file of uploadedFilesAudit[documentTypeId]; track file._id) {
            <div class="flex flex-col gap-2 border rounded-base p-2">
                <div class="flex flex-row items-center justify-between gap-2">
                    <div class="flex items-center gap-2">
                        <span class="text-sm font-semibold">{{file.upload.attachment?.filename}}</span>
                        <i class="pi pi-eye text-gray-400 cursor-pointer" (click)="openDocumentPreview(file)"></i>
                    </div>
                    <div class="flex items-center gap-2 px-2 py-1 rounded-base h-fit" [ngClass]="{
                        'text-success bg-green-50 border-1 border-green-600': file.upload.status === QNA_PAIR_METADATA_STATUS.COMPLETED, 
                        'text-arena-blue-600 bg-blue-50 border-1 border-blue-600': file.upload.status === QNA_PAIR_METADATA_STATUS.IN_PROGRESS, 
                        'text-danger bg-red-50 border-1 border-red-600': file.upload.status === QNA_PAIR_METADATA_STATUS.FAILED,
                        'text-gray-600 bg-gray-50 border-1 border-gray-600': file.upload.status === QNA_PAIR_METADATA_STATUS.PENDING
                    }">
                        <span class="text-xs">{{file.upload.status}}</span>
                    </div>
                </div>
                <!-- Credits-exhausted card: shown when this file's extraction was
                     paused due to insufficient credits.  The card self-transitions
                     from 'Get Credits' to 'Resume' once credits are topped up. -->
                @if (file.upload.status === QNA_PAIR_METADATA_STATUS.FAILED) {
                <app-credits-overview
                    variant="exhaustioncard"
                    feature="QUESTION_EXTRACTION"
                    [featureId]="file._id"
                    [credits]="creditsState.credits()"
                    [externalResume]="true"
                    (resume)="onResumeQnaExtraction(file)" />
                }
            </div>
            }
            }
        </div>
    </ng-template>
</p-drawer>
}

<!-- Data Table Templates -->
<ng-template #questionTemplateRef let-qna="$implicit">
    <div class="group">
        <div class="relative w-full h-full">
            <i class="pi pi-arrow-up-right-and-arrow-down-left-from-center absolute top-1 right-1 text-xs cursor-pointer p-1 border rounded-base bg-white shadow-md z-10 opacity-0 group-hover:opacity-100 transition-opacity"
                (click)="openModel(getQuestionTitle(qna), 'Question')"></i>
            <div class="line-clamp-3 text-sm overflow-hidden">{{ getQuestionTitle(qna) }}</div>
        </div>
    </div>
</ng-template>

<ng-template #answerTemplateRef let-qna="$implicit">
    <div class="overflow-hidden">
        <div class="relative w-full h-full group">
            <i class="pi pi-arrow-up-right-and-arrow-down-left-from-center absolute top-1 right-1 text-xs cursor-pointer p-1 border rounded-base bg-white shadow-md z-10 opacity-0 group-hover:opacity-100 transition-opacity"
                (click)="openModel(getAnswerValue(qna), 'Answer')"></i>
            <div class="prose prose-compact text-justify text-sm prose-ul:pl-1 prose-ol:pl-2 2xl:prose-ul:pl-4 2xl:prose-ol:pl-3 sm:prose-ul:pl-3 h-full overflow-y-auto"
                [innerHTML]="getAnswerValue(qna) | formatText : false" dynamicComponentRenderer
                style="line-height:1.5rem;">
            </div>
        </div>
    </div>
</ng-template>

<ng-template #authorTemplateRef let-qna="$implicit">
    <app-user-name-display [user]="qna.author" [fallbackText]="getAuthorName(qna)" />
</ng-template>

<ng-template #reviewedByTemplateRef let-qna="$implicit">
    @if(isReviewerDeactivated(qna)) {
    <span pTooltip="Account deactivated" tooltipPosition="bottom">
        <span class="text-sm font-medium text-gray-500 line-through">{{getReviewerName(qna)}}</span>
    </span>
    }@else {
    <span class="text-sm">{{getReviewerName(qna)}}</span>
    }
</ng-template>

<ng-template #documentTemplateRef let-qna="$implicit">
    <span class="text-sm">{{ getDocumentName(qna) }}</span>
</ng-template>

<ng-template #sourceTypeTemplateRef let-qna="$implicit">
    <span class="text-sm">{{ getSourceType(qna) }}</span>
</ng-template>

<ng-template #lastEditedTemplateRef let-qna="$implicit">
    <span class="text-sm">{{ getLastEditedDisplay(qna) }}</span>
</ng-template>